import { withFocusRing } from "@components/Accessibility/FocusRing/FocusRing";
import { Link } from "@components/Link/Link";
import { PageTitle } from "@components/PageTitle/PageTitle";
import { StyledButtonLink } from "@components/Styled/Button";
import { StyledContainer } from "@components/Styled/Container";
import React from "react";
import { withTitle } from "./withTitle";

import { clsx } from "clsx";

const Button = (props: any) => (
  <StyledButtonLink
    {...props}
    className={clsx(props.className, "my-mini w-full max-w-[330px]")}
  />
);

const UnderlinedButton = withFocusRing((props: any) => (
  <button
    {...props}
    className={clsx(
      props.className,
      "mb-mini border-b text-body leading-caption hover:border-warning hover:text-warning",
    )}
  />
));

export const Title = withTitle(
  ({
    styles,
    title,
    paths,
    buttonTitle,
    buttonLink,
    buttonStyle,
    content,
    width,
    textCenter,
    titleWidth,
    titleBackground,
  }) => (
    <PageTitle
      styles={styles}
      title={title}
      paths={paths}
      width={titleWidth}
      background={titleBackground}
      data-component-type="section-title"
    >
      <>
        {buttonLink && buttonStyle === "button" ? (
          <Button colour="secondary" height="56" textSize="16" to={buttonLink}>
            {buttonTitle}
          </Button>
        ) : null}
        {buttonLink && buttonStyle === "underlined" ? (
          <UnderlinedButton as={buttonLink ? Link : null} to={buttonLink}>
            {buttonTitle}
          </UnderlinedButton>
        ) : null}
        {content && (
          <StyledContainer width={width}>
            <div
              className={clsx(
                "rte mt-mini",
                textCenter ? "[&_p]:text-center" : "[&_p]:text-left",
              )}
            >
              {content}
            </div>
          </StyledContainer>
        )}
      </>
    </PageTitle>
  ),
);

export default Title;
